import { useLocation, useMatches } from "react-router-dom";
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import { type Handle } from "router";

type BreadcrumbsProps = {
  skipCurrent?: boolean;
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ skipCurrent }) => {
  const location = useLocation();
  const matches = useMatches();
  const crumbs = matches.filter(match => {
    if (skipCurrent && match.pathname === location.pathname) return false;
    return Boolean((match.handle as Handle)?.crumb)
  })

  return (
    <MuiBreadcrumbs>
      {crumbs.map((match) => {
        const crumb = (match.handle as Handle)?.crumb;
        return crumb;
      })}
    </MuiBreadcrumbs>
  );
}

export default Breadcrumbs;
